import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "className", "panelWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { Panel } from "../..";
import extractTheme from "./extractTheme";
/**
 * The ListBuilderPanel is the common component used to render Panel
 * component for both Edit and Reorder Panels.
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const ListBuilderPanel = /*#__PURE__*/React.forwardRef((_ref, userRef) => {
  let {
    children,
    className,
    panelWidth
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  const {
    cssRoot
  } = extractTheme({
    theme
  });
  /** Output from this method is what will be rendered into browser. */

  const panelClassNames = clsx("pnr-list-builder-panel", className);
  return _jsx(Panel, _objectSpread(_objectSpread({
    className: panelClassNames,
    closeTooltipPosition: "bottom-right",
    bodyRole: "document",
    customStyles: {
      root: cssRoot
    },
    width: panelWidth,
    ref: userRef
  }, otherProps), {}, {
    children: children
  }));
});
ListBuilderPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /** This is what will be displayed inside the Panel. */
  children: PropTypes.node.isRequired,

  /** The width of the ListBuilder Panels at a desktop breakpoint. */
  panelWidth: PropTypes.string
} : {};
ListBuilderPanel.defaultProps = {
  panelWidth: null
};
ListBuilderPanel.displayName = "ListBuilderPanel";
export default ListBuilderPanel;